module.exports = __webpack_public_path__ + "img/lea-48.e6cf1bfd.png";